import { render, staticRenderFns } from "./UpdatePlayerMatchName.vue?vue&type=template&id=1f9a1faa&scoped=true"
import script from "./UpdatePlayerMatchName.vue?vue&type=script&lang=js"
export * from "./UpdatePlayerMatchName.vue?vue&type=script&lang=js"
import style0 from "./UpdatePlayerMatchName.vue?vue&type=style&index=0&id=1f9a1faa&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f9a1faa",
  null
  
)

export default component.exports